module.exports = __webpack_public_path__ + "datasource.html";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=[name].[ext]!./src/datasourceApp/datasource.html
 ** module id = 180
 ** module chunks = 2
 **/